import { render, staticRenderFns } from "./RegisterSuite.vue?vue&type=template&id=52440585"
import script from "./RegisterSuite.vue?vue&type=script&lang=js"
export * from "./RegisterSuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports